<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row>
      <el-col :span="24" class="flex">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          v-model="searchFrom.classTableName"
          :placeholder="$t('pleaseSelectClass')"
          clearable
          filterable
          class="mr-10px input_width ml-10px"
          size="small"
        >
          <el-option
            v-for="item in classList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <el-input
          size="small"
          v-model="searchFrom.className"
          class="input_width m-r-10"
          placeholder="实体名称"
          clearable
        ></el-input>-->
        <el-date-picker
          v-model="searchFrom.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="mr-10px"
          @change="changeTime"
        >
        </el-date-picker>
        <el-button type="primary" @click="sizeChange">{{ $t('search') }}</el-button>
        <el-button @click="resetSearchQuery">{{ $t('reset') }}</el-button>
      </el-col>
    </el-row>
    <div class="w-full">
      <div class="w-full reconciliation_container">
        <div class="flex float-right">
          <div
            v-for="item in reconciliationList"
            :key="item.value"
            class="reconciliation_item"
            :class="
              currentSelectedReconciliation === item.value ? 'reconciliation_item_active' : ''
            "
            @click="reconciliationChange(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
    <el-row class="table_box mt-10px">
      <el-col :span="24" class="h-full">
        <el-table :data="tableList" height="calc(100% - 50px)" border v-loading="tableLoading">
          <el-table-column
            prop="className"
            :label="$t('entityName')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="estimatedAmount"
            :label="$t('estimatedAmount')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="realAmount"
            :label="$t('realAmount')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="acquisitionTime"
            :label="$t('acquisitionTime')"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column label="操作" align="center" width="60px">
            <template #default="{ row }">
              <el-tooltip content="查看" :open-delay="600" placement="top">
                <el-button
                  type="primary"
                  class="m-l-0 m-r-5 iconfont icon-display"
                  @click="viewDetail(row)"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>-->
        </el-table>
        <div class="tr">
          <el-pagination
            class="mt-20px float-right"
            background
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page.sync="page.pageNo"
            :page-sizes="$pageSizeAll"
            :page-size.sync="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.recordCount"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <viewReconciliation
      v-if="isShowViewDialog"
      :visible.sync="isShowViewDialog"
    ></viewReconciliation>
  </el-card>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'
import DataCollectionManageService from '@/services/dataCollectionManageService'
import dayjs from 'dayjs'
import selectStandardId from '../../components/selectStandardId'

const viewReconciliation = () => {
  return import('./components/viewReconciliation')
}

export default {
  name: 'reconciliationList',
  components: {
    viewReconciliation,
    selectStandardId,
  },
  watch: {
    standardId(newValue) {
      if (newValue) {
        this.getClassList()
        this.sizeChange()
      } else {
        this.classList = []
        this.searchFrom.classTableName = ''
      }
    },
  },
  data() {
    return {
      standardId: localStorage.getItem('standardId'), // 选择的标准id
      classList: [], // 实体下拉框
      searchFrom: {
        classTableName: '', //  选中的实体的tableName
        time: [],
      },
      reconciliationList: [
        {
          label: this.$t('dailyReconciliation'),
          value: 1,
        },
        {
          label: this.$t('weeklyReconciliation'),
          value: 2,
        },
        {
          label: this.$t('monthlyReconciliation'),
          value: 3,
        },
      ], // 对账时间段
      currentSelectedReconciliation: null, // 对账时间段当前选中项
      tableList: [], // 列表数据
      tableLoading: false, // 列表loading
      page: {
        pageNo: 1,
        pageSize: 15,
        recordCount: 0,
      }, // 分页数据
      isShowViewDialog: false, // 是否显示查看弹窗
    }
  },
  methods: {
    // 修改时间
    changeTime() {
      this.currentSelectedReconciliation = null
    },
    updateStandardId(val) {
      this.standardId = val
    },
    /**
     * @description 搜索
     */
    async getTableDataList() {
      this.tableLoading = true
      const payload = {
        StandardId: this.standardId,
        ClassId: this.searchFrom.classTableName,
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
        StartTime: this.searchFrom.time ? this.searchFrom.time[0] : '',
        EndTime: this.searchFrom.time ? this.searchFrom.time[1] : '',
        // Type: this.currentSelectedReconciliation, // 1为日对账 ，2为周，3为月
      }
      const res = await DataCollectionManageService.getList(payload)
      this.tableLoading = false
      if (res && res.data && res.code === 0) {
        this.tableList = res.data
        this.page.recordCount = res.totalCount
      }
    },

    /**
     * @description 重置
     */
    resetSearchQuery() {
      this.searchFrom = {
        classTableName: '',
        time: [],
      }
      this.currentSelectedReconciliation = null
      this.getTableDataList()
    },

    /**
     * @description 对账时间段切换
     * @param {Number} reconciliationValue
     */
    reconciliationChange(reconciliationValue) {
      this.searchFrom.time = []
      if (reconciliationValue === 1) {
        // 今天
        this.searchFrom.time.push(
          dayjs(new Date(new Date(new Date().toLocaleDateString()).getTime())).format(
            'YYYY-MM-DD HH:mm:ss'
          )
        )
      } else if (reconciliationValue === 2) {
        // 近7天
        this.searchFrom.time.push(
          dayjs(
            new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000)
          ).format('YYYY-MM-DD HH:mm:ss')
        )
      } else if (reconciliationValue === 3) {
        // 近30天
        this.searchFrom.time.push(
          dayjs(
            new Date(new Date(new Date().toLocaleDateString()).getTime() - 29 * 24 * 60 * 60 * 1000)
          ).format('YYYY-MM-DD HH:mm:ss')
        )
      }
      this.searchFrom.time.push(
        dayjs(
          new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
        ).format('YYYY-MM-DD HH:mm:ss')
      )
      if (this.currentSelectedReconciliation === reconciliationValue) {
        // 重复点击
        return
      }
      this.currentSelectedReconciliation = reconciliationValue
      this.getTableDataList()
    },

    /**
     * @description 查看
     */
    viewDetail() {
      this.isShowViewDialog = true
    },

    sizeChange() {
      this.page.pageNo = 1
      this.getTableDataList()
    },

    currentChange() {
      this.getTableDataList()
    },

    /**
     * @description 获取实体
     */
    async getClassList() {
      const parameter = {
        standard_id: this.standardId,
        keyword: '',
        pageno: 1,
        pagesize: 999,
        data_type: 1,
        parent_id: '',
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
  },
  async created() {
    if (this.standardId) {
      this.getTableDataList()
      this.getClassList()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style lang="scss" scoped>

/deep/ .el-card__body {
  height: 100%;
}
.input_width {
  width: 200px;
}
.table_box {
  height: calc(100% - 76px);
}
.reconciliation_container {
  overflow: hidden;
}
.reconciliation_item {
  font-size: 12px;
  border: 1px solid #ddd;
  padding: 5px 10px;
  cursor: pointer;
}
.reconciliation_item_active {
  color: #fff;
  background: #1890ff;
}

</style>
